import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api"; // Ensure this path matches your API utility file

export const fetchPayroll = createAsyncThunk(
  "payroll/fetchPayroll",
  async () => {
    const response = await api.post("/payroll-month-list");
    return response.data;
  }
);

export const addPayroll = createAsyncThunk(
  "payroll/addPayroll",
  async (payrollData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/generate-payroll", payrollData);
      dispatch(fetchPayroll());
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data.message || "Failed to save user"
      );
    }
  }
);

export const deletePayroll = createAsyncThunk(
  "payroll/deletePayroll",
  async (payrollId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-payroll/${payrollId}`);
      dispatch(fetchPayroll());
      return response.data.message; // Success message from backend
    } catch (error) {
      return rejectWithValue(
        error.response?.data.message || "Failed to delete user"
      );
    }
  }
);

// Define the initial state and slice
const payrollSlice = createSlice({
  name: "payrollData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openPayrollModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closePayrollModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayroll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPayroll.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchPayroll.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch users";
      })
      .addCase(addPayroll.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addPayroll.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addPayroll.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deletePayroll.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deletePayroll.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deletePayroll.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openPayrollModal, closePayrollModal, clearError } =
  payrollSlice.actions;
export default payrollSlice.reducer;
export { payrollSlice };
